import { Link } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { latestArticles } from "@/mocks/articles";

export default function LatestSection() {
  const list = latestArticles.slice(0, 6);

  return (
    <section
      aria-labelledby="latest-heading"
      className="w-full border-b border-background-200 bg-background-100/70"
    >
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8 md:py-16">
        <SectionHeading
          eyebrow="Latest Analysis"
          id="latest-heading"
          title="最新深度解读"
          desc="按发布时间排列的事件复盘。每一篇都可以独立阅读，结构一致，方便你横向对照不同事件的共同逻辑。"
          action={
            <Link
              to="/analysis"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer"
            >
              进入解读库
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          }
        />

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((article, index) => (
            <Reveal key={article.id} delay={index * 70}>
              <ArticleCard article={article} variant="feature" />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}